import { createStore } from "../../../../utils/createStore.ts";

export type ProfileSettingsTab = "profile" | "general" | "members" | "plan";

export const profileSettingsDialogStore = createStore(
  {
    isDialogOpen: false,
    profileSettingsTab: "profile" as ProfileSettingsTab,
  },
  ({ setter, set }) => ({
    openDialog: () => {
      setter("isDialogOpen")(true);
    },
    closeDialog: () => {
      setter("isDialogOpen")(false);
    },
    setProfileSettingsTab: setter("profileSettingsTab"),
    reset: () => {
      set({
        profileSettingsTab: "profile",
      });
    },
  }),
);
